@if (data(); as msg) {
    Updated <department-item [department]="msg.department" />
}
 